import StompMessage from './StompMessage';
import StompConfig from './StompConfig';
import { v4 as uuidv4 } from "uuid";
import {FrameImpl} from "@stomp/stompjs";
import {Parser} from "@stomp/stompjs";

export default class SharedWorkerStompClient {

    // private
    #sharedWorker;
    #stompConfig;
    #frameParser;
    #subscriberToCallback = {};
    #clientId; // public onMessage needs access and is from a non-instance accessor
    #listener;

    //properties
    brokerURL;
    reconnectDelay;
    heartbeatIncoming;
    heartbeatOutgoing;  




    constructor(sharedWorker, stompConfig) {
        this.#sharedWorker = sharedWorker;
        this.#stompConfig = stompConfig;
        this.brokerURL = stompConfig.brokerURL;
        this.reconnectDelay = stompConfig.reconnectDelay;
        this.heartbeatIncoming = stompConfig.heartbeatIncoming;
        this.heartbeatOutgoing = stompConfig.heartbeatOutgoing;
        this.escapeHeaderValues = stompConfig.escapeHeaderValues || true; 
        this.appendMissingNullOnIncoming = stompConfig.appendMissingNullOnIncoming || false;
        this.#clientId = uuidv4();
        this.#listener = (evt)=>{
            this.onMessage(evt);
        }
        this.#sharedWorker.port.addEventListener('message', this.#listener);
        this.postMessage(
            StompMessage.create(
                this.#clientId,
                stompConfig.brokerURL,
                StompMessage.REQUEST_CREATE,
                StompConfig.create(stompConfig)
            ));
        this.#frameParser = new Parser(
            (rawFrame)=>{
                const frame = FrameImpl.fromRawFrame(rawFrame, this.escapeHeaderValues);
                let subscription_id = frame.headers.destination;
                let callback = this.#subscriberToCallback[subscription_id];
                if(!!callback){
                    callback(frame);
                }else{
                    console.log(`Error: callback not found for subscription: ${subscription_id}` );
                }
            },
            () => {
                console.log("incoming ping: no-op.");
            }
        );
    }

    activate() {
        this.postMessage(
            StompMessage.create(
                this.#clientId,
                this.#stompConfig.brokerURL,
                StompMessage.REQUEST_ACTIVATE));
    }

    deactivate() {
        this.postMessage(StompMessage.create(
            this.#clientId,
            this.#stompConfig.brokerURL,
            StompMessage.REQUEST_DEACTIVATE)
        );
        
        this.#sharedWorker.port.removeEventListener("message", this.#listener);
    }

    subscribe(
        destination,
        callback,
        headers
    ) {
        this.#subscriberToCallback[destination] = callback;
        this.postMessage(
            StompMessage.create(
                this.#clientId,
                this.#stompConfig.brokerURL,
                StompMessage.REQUEST_SUBSCRIBE,
                {
                    destination: destination,
                    headers, headers,
                }
            )
        );
    }

    publish(data) {
        this.postMessage(
            StompMessage.create(
                this.#clientId,
                this.#stompConfig.brokerURL,                
                StompMessage.REQUEST_PUBLISH,
                data // comprises: {destination:{}, body:{}}
            )
        );
    }
    onBrokerConnectionCheck(data){
        // yes, I'm here
        this.postMessage(
            StompMessage.create(
                this.#clientId,
                this.#stompConfig.brokerURL,                
                StompMessage.SHARED_WORKER_CLIENT_CONNECTION_ACK,
                {}
            )
        );
    }
    onMessage(event) {
        let message = event.data;
        let name = message.name;
        let data = message.data;
        let destinationId = message.destinationId;
        let senderId = message.senderId;
        //UV6-1581 console.log(`incoming: ${name} sender: ${senderId} destination: ${destinationId} myId: ${this.#clientId}`); 

        if(
            (destinationId.includes(StompMessage.NONSPECIFIC_ID) || destinationId.includes(this.#clientId)) &&
            (senderId.includes(this.#stompConfig.brokerURL)||(senderId.includes(StompMessage.NONSPECIFIC_ID)))
        ){        
            //UV6-1581 console.log(`handling message: ${name}` ); 
            switch (name) {
                case StompMessage.BROKER_BEFORE_CONNECT:
                    this.#stompConfig.beforeConnect(data);
                    break;
                case StompMessage.BROKER_CONNECT:
                    this.#stompConfig.onConnect(data);
                    break;
                case StompMessage.BROKER_WEBSOCKET_CLOSE:
                    this.#stompConfig.onWebSocketClose(data);
                    break;
                case StompMessage.BROKER_WEBSOCKET_ERROR:
                    this.#stompConfig.onWebSocketError(data);
                    break;
                case StompMessage.BROKER_STOMP_ERROR:
                    this.#stompConfig.onStompError(data);
                    break;
                case StompMessage.SHARED_WORKER_ERROR:
                    console.log(`worker_error: ${data.code}: ${data.description}`);
                    this.#stompConfig.onWebSocketClose(data);
                    break;
                case StompMessage.BROKER_STOMP_SUBSCRIBED_CALLBACK:
                    this.#frameParser.parseChunk(data);
                    break;        
                case StompMessage.SHARED_WORKER_BROKER_CONNECTION_CHECK:
                    this.onBrokerConnectionCheck(data);
                    break;
            }
        }else{
            //UV6-1581 console.log(`ignoring message: ${name}` ); 
        }
    }

    postMessage(message){
        //UV6-1581 console.log(`outgoing: ${message.name}`);
        this.#sharedWorker.port.postMessage(message);
    }






}